import Api from './Api'
export default {
  dashboard: () => Api().get('/dashboard-operativo'),
  siniestros: (params = {}) => Api().get('/siniestros-operativos', { params }),
  siniestro: (id) => Api().get(`/siniestros-operativos/${id}`),
  actualizarSiniestro: (id, data) => Api().put(`/siniestros-operativos/${id}`, data),
  todosDocumentos: (params = {}) => Api().get('/documentos-unificados', { params }),
  documentos: (type, id) => Api().get(`/documentos/${type}/${id}`),
  subirDocumento: (type, id, data) => Api().post(`/documentos/${type}/${id}`, data),
  async descargarDocumento(fileDocument) {
    const response = await Api().get(`/documentos-unificados/${fileDocument.id}/descargar`, { responseType: 'blob' })
    const url = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = url
    link.download = fileDocument.nombre || 'documento'
    link.click()
    URL.revokeObjectURL(url)
  },
  eliminarDocumento: (id) => Api().delete(`/documentos-unificados/${id}`),
  auditoria: (params = {}) => Api().get('/auditoria', { params }),
  async exportar(type) {
    const response = await Api().get(`/reportes/${type}.csv`, { responseType: 'blob' })
    const url = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = url
    link.download = `${type}.csv`
    link.click()
    URL.revokeObjectURL(url)
  },
}
